/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AvailabilityBisNew model module.
 * @module model/AvailabilityBisNew
 * @version 1.0.0
 */
class AvailabilityBisNew {
    /**
     * Constructs a new <code>AvailabilityBisNew</code>.
     * @alias module:model/AvailabilityBisNew
     */
    constructor() { 
        
        AvailabilityBisNew.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AvailabilityBisNew</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AvailabilityBisNew} obj Optional instance to populate.
     * @return {module:model/AvailabilityBisNew} The populated <code>AvailabilityBisNew</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AvailabilityBisNew();

            if (data.hasOwnProperty('availability')) {
                obj['availability'] = ApiClient.convertToType(data['availability'], 'String');
            }
            if (data.hasOwnProperty('from_time')) {
                obj['from_time'] = ApiClient.convertToType(data['from_time'], 'String');
            }
            if (data.hasOwnProperty('to_time')) {
                obj['to_time'] = ApiClient.convertToType(data['to_time'], 'String');
            }
            if (data.hasOwnProperty('text')) {
                obj['text'] = ApiClient.convertToType(data['text'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} availability
 */
AvailabilityBisNew.prototype['availability'] = undefined;

/**
 * @member {String} from_time
 */
AvailabilityBisNew.prototype['from_time'] = undefined;

/**
 * @member {String} to_time
 */
AvailabilityBisNew.prototype['to_time'] = undefined;

/**
 * @member {String} text
 */
AvailabilityBisNew.prototype['text'] = undefined;






export default AvailabilityBisNew;

